import { defineStore } from 'pinia';
import type { VolumeDiscount } from '~~/types/discounts';

export const volumeDiscountsStore = defineStore('volumeDiscounts', {
  state: () => ({
    volumeDiscountConfigurations: {},
  }),
  getters: {
    isGroupActive: (state) => {

      return (volumeDiscountGroup: string) => {

        const group = state.volumeDiscountConfigurations[volumeDiscountGroup];

        return !!group && group.length > 0;
      
      };
    
    },
  },
  actions: {
    setGroup(payload: { groupKey: string, value: VolumeDiscount[] }) {

      this.volumeDiscountConfigurations = {
        ...this.volumeDiscountConfigurations,
        [payload.groupKey]: payload.value,
      }; 

    },
  },
});
